var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_291_3410)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 8,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5148 9.16397C11.5148 8.9073 11.5478 8.69097 11.6138 8.51497C11.6872 8.33164 11.7788 8.17397 11.8888 8.04197C12.0062 7.90264 12.1235 7.7743 12.2408 7.65697C12.3655 7.5323 12.4828 7.4113 12.5928 7.29397C12.7102 7.1693 12.8018 7.02997 12.8678 6.87597C12.9412 6.72197 12.9778 6.53864 12.9778 6.32597C12.9778 6.17197 12.9522 6.0363 12.9008 5.91897C12.8495 5.80164 12.7725 5.70264 12.6698 5.62197C12.5745 5.5413 12.4608 5.48264 12.3288 5.44597C12.2042 5.40197 12.0648 5.37997 11.9108 5.37997C11.6908 5.37997 11.4855 5.41664 11.2948 5.48997C11.1115 5.5633 10.9465 5.6733 10.7998 5.81997C10.7192 5.9153 10.6678 5.98864 10.6458 6.03997C10.6312 6.0913 10.6238 6.1463 10.6238 6.20497L10.5688 6.27097L10.4808 6.20497L9.79883 5.69897C9.96749 5.4423 10.1508 5.22597 10.3488 5.04997C10.5542 4.87397 10.7888 4.7383 11.0528 4.64297C11.3242 4.54764 11.6322 4.49997 11.9768 4.49997C12.3875 4.49997 12.7432 4.58064 13.0438 4.74197C13.3518 4.89597 13.5865 5.10864 13.7478 5.37997C13.9165 5.64397 14.0008 5.94464 14.0008 6.28197C14.0008 6.56064 13.9642 6.79897 13.8908 6.99697C13.8175 7.19497 13.7222 7.3673 13.6048 7.51397C13.4948 7.6533 13.3738 7.78164 13.2418 7.89897C13.1098 8.0163 12.9852 8.13364 12.8678 8.25097C12.7578 8.36097 12.6625 8.4893 12.5818 8.63597C12.5085 8.78264 12.4718 8.95864 12.4718 9.16397V9.68097H11.5148V9.16397ZM12.0208 11.98C11.8082 11.98 11.6248 11.9066 11.4708 11.76C11.3242 11.606 11.2508 11.4226 11.2508 11.21C11.2508 11.0046 11.3242 10.8286 11.4708 10.682C11.6248 10.528 11.8082 10.451 12.0208 10.451C12.2262 10.451 12.4022 10.528 12.5488 10.682C12.7028 10.8286 12.7798 11.0046 12.7798 11.21C12.7798 11.4226 12.7028 11.606 12.5488 11.76C12.4022 11.9066 12.2262 11.98 12.0208 11.98Z",
    fill: "#FBFBFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_291_3410",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_291_3410"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_291_3410",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/questionIcon.e28cb49015a3e8e40aea3b2088634e23.svg";
export { ForwardRef as ReactComponent };